import { render, staticRenderFns } from "./Confirmation_comp.vue?vue&type=template&id=7dff6f23&scoped=true&"
import script from "./Confirmation_comp.vue?vue&type=script&lang=js&"
export * from "./Confirmation_comp.vue?vue&type=script&lang=js&"
import style0 from "./Confirmation_comp.vue?vue&type=style&index=0&id=7dff6f23&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dff6f23",
  null
  
)

export default component.exports